import {OPERATORS} from "../../../helpers/generateQueryUrl";
import {useSearchOptions} from "../../../hooks/useSearchOptions";
import {inventoryReportsURL} from "./inventoryReportsTable.constants";

export const useInventoryReportsSearchOptions = () => {
  const options = useSearchOptions(inventoryReportsURL, [
    "user_by",
    "customer",
    "site",
    "location",
    "organization",
    "serial",
  ]);

  const searchOptions = [
    {
      category: {label: "Serial", value: "serial"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.serial,
    },
    {
      category: {label: "Organization", value: "organization"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.organization,
    },
    {
      category: {label: "Customer", value: "customer"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.customer,
    },
    {
      category: {label: "Site", value: "site"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.site,
    },
    {
      category: {label: "Location", value: "location"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.location,
    },
    {
      category: {label: "Action", value: "action"},
      operator: ["="],
      options: [
        {label: "CLAIMED", value: "CLAIMED"},
        {label: "UNCLAIMED", value: "UNCLAIMED"},
      ],
    },
    {
      category: {label: "User By", value: "user_by"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.user_by,
    },
    {
      category: {label: "Event At", value: "event_at"},
      operator: [OPERATORS.ON_OR_BEFORE, OPERATORS.ON_OR_AFTER],
      type: "date",
      isAllowDuplicateCategories: true,
    },
  ];

  return {searchOptions};
};
